<template>
  <svg class="light-icon" viewBox="0 0 32 32">
    <path
      d="M16 12.005a4 4 0 1 1-4 4a4.005 4.005 0 0 1 4-4m0-2a6 6 0 1 0 6 6a6 6 0 0 0-6-6z"
      fill="currentColor"
    />
    <path
      d="M5.394 6.813l1.414-1.415l3.506 3.506L8.9 10.318z"
      fill="currentColor"
    />
    <path d="M2 15.005h5v2H2z" fill="currentColor" />
    <path
      d="M5.394 25.197L8.9 21.691l1.414 1.415l-3.506 3.505z"
      fill="currentColor"
    />
    <path d="M15 25.005h2v5h-2z" fill="currentColor" />
    <path
      d="M21.687 23.106l1.414-1.415l3.506 3.506l-1.414 1.414z"
      fill="currentColor"
    />
    <path d="M25 15.005h5v2h-5z" fill="currentColor" />
    <path
      d="M21.687 8.904l3.506-3.506l1.414 1.415l-3.506 3.505z"
      fill="currentColor"
    />
    <path d="M15 2.005h2v5h-2z" fill="currentColor" />
  </svg>
</template>
